<template>
  <div v-if="minTable" class="border pa-1 mb-1">
    <div>
      <div class="d-flex align-center">
        {{ formatDate(item['report_sent_at']) }}
        <BaseTooltip
          v-if="item['report_sender']"
          :tooltip="item['report_sender'].first_name + ' ' + item['report_sender'].last_name"
        >
          <div class="ml-3 mt-2">
            <IconsButton icon="button-contact" width="24" height="24" color="#277FAF"/>
          </div>
        </BaseTooltip>
      </div>
      <div class="d-flex align-center">
        <template v-if="item['report_sign_photo']">
          <v-dialog v-if="fileType === 'image'" v-model="modal" width="1200">
            <template v-slot:activator="{ on, attrs }">
              <v-btn text icon v-bind="attrs" v-on="on">
                <slot name="icon">
                  <IconTimeControlBill icon="green"/>
                </slot>
              </v-btn>
            </template>
            <v-img :src="apiDomain + '/' + item['report_sign_photo']" class="mx-auto" contain>
              <template v-slot:placeholder>
                <v-row
                  class="fill-height ma-0"
                  align="center"
                  justify="center"
                >
                  <v-progress-circular
                    indeterminate
                    color="secondary lighten-5"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
            <v-btn @click="modal = false" fixed top right fab small dark class="mt-16">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-btn :href="apiDomain + '/' + item['report_sign_photo']" target="_blank" fixed bottom right fab dark
                   class="mb-16" color="#277faf">
              <IconsButton icon="button-save" width="30" height="30"/>
            </v-btn>
          </v-dialog>
          <PdfModalShow v-else :url="item['report_sign_photo']"/>
        </template>
        <BaseTooltip v-else :tooltip="status.text">
          <div class="d-flex fill-height align-center">
            <IconTimeControlBill :icon="status.icon" class="mr-2"/>
          </div>
        </BaseTooltip>
        <div class="text-no-wrap">{{ status.date }}</div>
        <BaseTooltip
          v-if="item['client_person_data'] || item['report_signer_user']"
          :tooltip="item['client_person_data']
            ? item['client_person_data'].first_name + ' ' + item['client_person_data'].last_name
            : item['report_signer_user'].first_name + ' ' + item['report_signer_user'].last_name"
        >
          <div class="ml-3 mt-1">
            <IconsButton icon="button-contact" width="24" height="24" color="#277FAF"/>
          </div>
        </BaseTooltip>
      </div>
      <div class="grid_btn_mobile d-flex justify-space-around align-center">
        <ButtonShow :open-modal="onOpenItem"/>
        <StatisticProjectReportsSignSendModal
          v-if="item['report_status'] === 'sent'
            || item['report_status'] === 'expired'
            || item['report_status'] === 'canceled'
            || item['report_status'] === 'approved'"
          :work_client_id="project.work_client.id"
          :bill-id="item.id"
          icon-size="20"
        />
        <DeleteModal
          v-if="!item['report_status'] || item['report_status'] === 'expired'"
          :method-delete="onDeleteItem"
          ref="deleteModal"
        />
        <div v-if="item['report_status'] === 'approved'">
          <PdfDocumentCreate
            :upload-function="billSign"
            :open-function="formBill"
            :min-button="$vuetify.breakpoint.mdAndUp"
          />
          <StatisticProjectReportsBlankPDF
            v-if="workClientProjectsClientBillsShow.data"
            invisible
            :project="projectPDF"
            :date="datePDF"
            :total_works="workClientProjectsClientBillsShow.data['reports_data']['work_types']"
            :total_extras="workClientProjectsClientBillsShow.data['reports_data']['extras']"
            formed
            ref="pdf"
          />
        </div>
      </div>
    </div>
  </div>
  <tr v-else>
    <td>
      <div class="d-flex align-center">
        {{ formatDate(item['report_sent_at']) }}
        <BaseTooltip
          v-if="item['report_sender']"
          :tooltip="item['report_sender'].first_name + ' ' + item['report_sender'].last_name"
        >
          <div class="ml-3">
            <IconsButton icon="button-contact" width="24" height="24" color="#277FAF"/>
          </div>
        </BaseTooltip>
      </div>
    </td>
    <td class="grid">
      <BaseTooltip :tooltip="status.text">
        <div class="d-flex fill-height align-center">
          <template v-if="item['report_sign_photo']">
            <v-dialog v-if="fileType === 'image'" v-model="modal" width="1200">
              <template v-slot:activator="{ on, attrs }">
                <v-btn text icon v-bind="attrs" v-on="on">
                  <slot name="icon">
                    <IconTimeControlBill icon="green"/>
                  </slot>
                </v-btn>
              </template>
              <v-img :src="apiDomain + '/' + item['report_sign_photo']" class="mx-auto" contain>
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="secondary lighten-5"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
              <v-btn @click="modal = false" fixed top right fab small dark class="mt-16">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-btn :href="apiDomain + '/' + item['report_sign_photo']" target="_blank" fixed bottom right fab dark
                     class="mb-16" color="#277faf">
                <IconsButton icon="button-save" width="30" height="30"/>
              </v-btn>
            </v-dialog>
            <PdfModalShow v-else :url="item['report_sign_photo']"/>
          </template>
          <IconTimeControlBill v-else :icon="status.icon"/>
        </div>
      </BaseTooltip>
      <div class="d-flex fill-height align-center">
        {{ status.date }}
        <BaseTooltip
          v-if="item['client_person_data'] || item['report_signer_user']"
          :tooltip="item['client_person_data']
            ? item['client_person_data'].first_name + ' ' + item['client_person_data'].last_name
            : item['report_signer_user'].first_name + ' ' + item['report_signer_user'].last_name"
        >
          <div class="ml-3 mt-1">
            <IconsButton icon="button-contact" width="24" height="24" color="#277FAF"/>
          </div>
        </BaseTooltip>
        <div v-else style="width: 38px"/>
        <div class="ml-10">
          <ButtonShow :open-modal="onOpenItem"/>
        </div>
        <div class="grid_btn">
          <StatisticProjectReportsSignSendModal
            v-if="item['report_status'] === 'sent' || item['report_status'] === 'expired' || item['report_status'] === 'canceled' || item['report_status'] === 'approved'"
            :work_client_id="project.work_client.id"
            :bill-id="item.id"
            icon-size="20"
          />
          <DeleteModal
            v-if="!item['report_status'] || item['report_status'] === 'expired'"
            :method-delete="onDeleteItem"
            ref="deleteModal"
          />
          <div v-if="item['report_status'] === 'approved'">
            <PdfDocumentCreate
              :upload-function="billSign"
              :open-function="formBill"
              min-button
            />
            <StatisticProjectReportsBlankPDF
              v-if="workClientProjectsClientBillsShow.data"
              invisible
              :project="projectPDF"
              :date="datePDF"
              :total_works="workClientProjectsClientBillsShow.data['reports_data']['work_types']"
              :total_extras="workClientProjectsClientBillsShow.data['reports_data']['extras']"
              formed
              ref="pdf"
            />
          </div>
        </div>
      </div>
    </td>
    <td></td>
  </tr>
</template>

<script>
import IconTimeControlBill from "../../icons/timeControl/IconTimeControlBill";
import BaseTooltip from "../../base/BaseTooltip";
import IconsButton from "../../icons/button/IconsButton";
import DeleteModal from "../../DeleteModal";
import StatisticProjectReportsSignSendModal from "./StatisticProjectReportsSignSendModal";
import PdfModalShow from "../../pdf/PdfModalShow";
import ButtonShow from "components/ButtonShow";
import {mapActions, mapGetters} from "vuex";
import PdfDocumentCreate from "components/pdf/pdfDocument/PdfDocumentCreate";
import StatisticProjectReportsBlankPDF from "components/timeControl/reports/blank/pdf/StatisticProjectReportsBlankPDF";

export default {
  name: "StatisticProjectReportsTableBill",
  components: {
    StatisticProjectReportsBlankPDF,
    PdfDocumentCreate,
    ButtonShow,
    PdfModalShow,
    StatisticProjectReportsSignSendModal, DeleteModal, IconsButton, BaseTooltip, IconTimeControlBill
  },
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    },
    deleteItem: {},
    project: {
      type: Object,
      default: () => {
        return {work_client: {}}
      }
    },
    minTable: Boolean
  },
  data: () => ({
    modal: false,
  }),
  computed: {
    ...mapGetters(['apiDomain']),
    ...mapGetters('workClientProjectsClientBills', ['workClientProjectsClientBillsShow']),
    status() {
      switch (this.item['report_status']) {
        case 'sent':
          return {
            text: this.localStorage.translations.pages.projects['reports_table'].sent,
            icon: 'yellow',
            date: this.formatDate(this.item['report_sent_at'])
          }
        case 'approved':
          return {
            text: this.localStorage.translations.pages.projects['reports_table'].approved,
            icon: 'yellow',
            date: this.formatDate(this.item['report_sent_at'])
          }
        case 'viewed':
          return {
            text: this.localStorage.translations.pages.projects['reports_table']['viewed'],
            icon: 'yellow',
            date: this.formatDate(this.item['report_opened_at'])
          }
        case 'signed':
          return {
            text: this.localStorage.translations.pages.projects['reports_table'].signed,
            icon: 'green',
            date: this.formatDate(this.item['report_signed_at'])
          }
        case 'expired':
          return {
            text: this.localStorage.translations.pages.projects['reports_table']['expired'],
            icon: 'gray',
            date: this.formatDate(this.item['report_link_expired_at'])
          }
        case 'canceled':
          return {
            text: this.localStorage.translations.pages.projects['reports_table']['canceled'],
            icon: 'red',
            date: this.formatDate(this.item['report_canceled_at'])
          }
        default:
          return {}
      }
    },
    fileType() {
      if (this.item['report_sign_photo']) {
        if (typeof this.item['report_sign_photo'] === 'string')
          return this.item['report_sign_photo'].split('.')[1] === 'pdf' ? 'application' : 'image'
        return this.item['report_sign_photo'].type.split('/')[0]
      }
      return ''
    },
    projectPDF() {
      let temp = {}
      if (this.workClientProjectsClientBillsShow && this.workClientProjectsClientBillsShow.data) {
        temp = Object.assign({}, this.workClientProjectsClientBillsShow.data['project_data'])
        temp.client = this.workClientProjectsClientBillsShow.data['client_data']
        temp.manager = {
          first_name: this.workClientProjectsClientBillsShow.data.project_data.manager.first_name,
          last_name: this.workClientProjectsClientBillsShow.data.project_data.manager.last_name,
          phone: this.workClientProjectsClientBillsShow.data.project_data.manager.phone
        }
        temp.name = temp.project_name
      }
      return temp
    },
    datePDF() {
      let temp = ''
      if (this.workClientProjectsClientBillsShow && this.workClientProjectsClientBillsShow.data) {
        let start_date = this.workClientProjectsClientBillsShow.data['period_data']['start_date']
        let end_date = this.workClientProjectsClientBillsShow.data['period_data']['end_date']
        temp = this.$formatDate(start_date) + (end_date ? (' - ' + this.$formatDate(end_date)) : '') + (this.showSelectedWeeks ? (' Vk ' + this.showSelectedWeeks) : '')
      }
      return temp
    },
  },
  methods: {
    ...mapActions(['uploadFile']),
    ...mapActions('workClientProjectsClientReports', ['onWorkClientProjectsClientReportsBillSign']),
    ...mapActions('workClientProjectsClientBills', ['onWorkClientProjectsClientBillShowToSign']),
    formatDate(data) {
      let temp = ['', '']
      if (data) {
        temp = data.split(' ')
        temp[0] = temp[0].split('-')
        temp[0] = temp[0][2] + '.' + temp[0][1] + '.' + temp[0][0]
      }
      return temp[0] + ' ' + temp[1]
    },
    onDeleteItem() {
      if (this.deleteItem) this.deleteItem(this.item.id)
      this.$refs.deleteModal.closeModal()
    },
    onOpenItem() {
      this.$router.push({
        name: 'timeControlShowReportsViewBill',
        params: {report_id: this.item.period_report_id, bill: this.item.id},
      })
    },
    async billSign(url) {
      if (this.$refs.pdf) {
        let total = this.$refs.pdf.$refs['pdf-main'].getBase64()
        fetch(total)
          .then(res => res.blob())
          .then(blob => {
            const file = new File([blob], "File name",{ type: "image/png" })
            this.saveChanges(url)
          })
      }
    },

    async saveChanges(full) {
      await this.onWorkClientProjectsClientReportsBillSign({
        id: this.item.id,
        data: {
          sign_photo: full,
          sign_photo_total: full,
          language_id: this.localStorage.translations.language_id
        }
      })
        .then(() => {
          this.$router.push({name: 'timeControlShowReports'})
        })
    },

    formBill() {
      this.onWorkClientProjectsClientBillShowToSign({id: this.item.id})
    },
  }
}
</script>

<style scoped lang="scss">
.grid {
  padding-left: 12px;
  display: grid;
  grid-template-rows: auto;
  grid-template-columns: 40px 1fr;
  align-items: center;

  &_btn_mobile {
    height: 100%;
    min-height: 50px;
    gap: 5px;

    :deep() .v-btn {
      background-color: transparent !important;
      color: #277FAF !important;
      max-height: 40px !important;
    }
  }

  &_btn {
    display: grid;
    grid-template-columns: 50px 50px 50px;
    height: 100%;
    gap: 5px;
    justify-items: center;
    margin-left: 20%;

    :deep() .v-btn {
      background-color: transparent !important;
      color: #277FAF !important;
      max-height: 40px !important;
    }
  }
}

.line {
  min-height: 55px;
  border-bottom: 1px solid gainsboro;

  &:last-child {
    border-bottom: none;
  }
}

.border {
  border: 1px solid rgba(black, 0.1);
  border-radius: 4px;
}

.fileInput {
  display: none;
}
</style>
